export default __webpack_public_path__ + "static/media/imageThree.9286bc05.png";